import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { BehaviorSubject, from, Observable, of, throwError } from 'rxjs';
import { LoginService } from './login.service';
import { Router } from '@angular/router';
import { catchError, filter, switchMap, take, tap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';

@Injectable()
export class TokenInetrcptInterceptor implements HttpInterceptor {

    private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  constructor(private loginService: LoginService, private router: Router, private _snackBar: MatSnackBar) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
       // Procesamos la consulta clonada y si el error es Unauthorized nos redirige al login
  const hasBearerToken = request.headers.has('authorization') && 
                            request.headers.get('authorization')?.startsWith('Bearer ');

      // Si no tiene bearer token o es la llamada a refreshToken, continuar sin interceptar
      if (!hasBearerToken || this.isRefreshTokenRequest(request)) {
        return next.handle(request);
      }
    // return next.handle(requestCloned).pipe(
    //   catchError((err: HttpErrorResponse) => {

    //     console.error(err);
    //     switch(err.status){
    //       case 401:
    //         this._snackBar.open('La sesión ha caducado.', 'Cerrar', {duration: 4000});
    //         this.router.navigate(['/IniPage']);
    //         return from(next.handle(requestCloned)); //probar de retornar un 200 para que no te salte el otro error.
    //         break;
    //       case 200: //Error si el resultado no es jso
    //       case 404:
    //          return from (next.handle(requestCloned));
    //           break;


    //       default:
    //         return throwError( err );
    //     }



    //   })
    // ).toPromise();
     return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Si el error es 401 (Unauthorized)
        if (error.status === 401) {
          return this.handle401Error(request, next);
        }
        return throwError( error);
      })
    );
  }
  private isRefreshTokenRequest(request: HttpRequest<unknown>): boolean {
    const refreshTokenUrl = `${environment.ApiUrlV3}api/Authentication/RefreshToken`;
    return request.url === refreshTokenUrl;
  }
  async interceptAsync(request: HttpRequest<unknown>, next: HttpHandler) {
    // Obtenemos el token de la autorizacion de la consulta

  
    // Procesamos la consulta clonada y si el error es Unauthorized nos redirige al login
  const hasBearerToken = request.headers.has('authorization') && 
                            request.headers.get('authorization')?.startsWith('Bearer ');

      // Si no tiene bearer token o es la llamada a refreshToken, continuar sin interceptar
      if (!hasBearerToken || this.isRefreshTokenRequest(request)) {
        return next.handle(request);
      }
    // return next.handle(requestCloned).pipe(
    //   catchError((err: HttpErrorResponse) => {

    //     console.error(err);
    //     switch(err.status){
    //       case 401:
    //         this._snackBar.open('La sesión ha caducado.', 'Cerrar', {duration: 4000});
    //         this.router.navigate(['/IniPage']);
    //         return from(next.handle(requestCloned)); //probar de retornar un 200 para que no te salte el otro error.
    //         break;
    //       case 200: //Error si el resultado no es jso
    //       case 404:
    //          return from (next.handle(requestCloned));
    //           break;


    //       default:
    //         return throwError( err );
    //     }



    //   })
    // ).toPromise();
     return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Si el error es 401 (Unauthorized)
        if (error.status === 401) {
          return this.handle401Error(request, next);
        }
        return throwError(error);
      })
    );
  }

  private handle401Error(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Si no estamos refrescando el token, iniciar el proceso
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.loginService.refreshToken().pipe(
        tap(() => {
          // Después de que refreshToken complete, obtener el nuevo token
          const loginData = this.loginService.getUserLocalStorage();
          const newToken = loginData.Token.Token;
          this.refreshTokenSubject.next(newToken);
        }),
        switchMap(() => {
          this.isRefreshing = false;
          
          // Obtener el nuevo token del localStorage
          const loginData = this.loginService.getUserLocalStorage();
          const newToken = loginData.Token.Token;

          if (newToken) {
            // Repetir la petición original con el nuevo token
            return next.handle(this.addTokenHeader(request, newToken));
          }

          // Si no hay token, redirigir al login
          this.redirectToLogin();
          return throwError(() => new Error('No se pudo obtener el nuevo token'));
        }),
        catchError((error: HttpErrorResponse) => {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(null);
          
          // Si el refresh token también retorna 401, redirigir al login
          if (error.status === 401) {
            this.redirectToLogin();
          }
          
          return throwError(() => error);
        })
      );
    } else {
      // Si ya estamos refrescando, esperar a que termine y luego repetir la petición
      return this.refreshTokenSubject.pipe(
        filter(token => token !== null),
        take(1),
        switchMap((token) => {
          if (!token) {
            // Si no hay token (refreshToken falló), redirigir al login
            this.redirectToLogin();
            return throwError(() => new Error('No se pudo refrescar el token'));
          }
          return next.handle(this.addTokenHeader(request, token));
        }),
        catchError((error: HttpErrorResponse) => {
          // Si la segunda petición también falla con 401, redirigir al login
          if (error.status === 401) {
            this.redirectToLogin();
          }
          return throwError(() => error);
        })
      );
    }
  }
    private addTokenHeader(request: HttpRequest<unknown>, token: string): HttpRequest<unknown> {
    return request.clone({
      headers: request.headers.set('authorization', `Bearer ${token}`)
    });
  }
   private redirectToLogin(): void {
    // Limpiar el localStorage antes de redirigir
     this._snackBar.open('La sesión ha caducado.', 'Cerrar', {duration: 4000});
     this.router.navigate(['/IniPage']);
    
  }
}
